import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 25,
        minHeight: 350
    },
    title: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 20
    },
    iconSelect: {
        width: 17,
        height: 18
    },
    contentSelect: {
        alignSelf: 'center',
    },
    dropdown: {
        width: '70%',
        height: 30,
        marginTop: 15
    },
    textAmount: {
        fontSize: 18,
        color: '#5eb2a9',
        fontWeight: 'bold',
        marginTop: 35
    },
    price: {
        textAlign: 'center',
        fontSize: 12,
        marginTop: 15
    },
    action_buttons_container: {
        paddingHorizontal: "30%",
        marginTop: 15
    },
    action_button: {
        padding: 10,
        borderRadius: 20,
    },
    action_button_text: {
        textTransform: "uppercase",
        fontWeight: "bold",
        color: "#FFF",
        textAlign: 'center'
    },
    contentBtn: {
        position: 'absolute',
        bottom: 50,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
    numberInput: {
        flex: 1,
        backgroundColor: "#f1f1f1",
        borderWidth: 1,
        borderColor: "#ccc"
    },
    contentPurchase: {
        backgroundColor: "#f1f1f1",
        paddingHorizontal: 0,
        marginTop: 20
    },
    titlePurchase: {
        textAlign: 'center',
        marginBottom: 20,
    },
    contentPurchaseAmount: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
});

export default styles;
